var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconfaSolidNetworkWired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.742,
    height: 96.594,
    viewBox: "0 0 120.742 96.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-network-wired",
    "data-name": "Icon fa-solid-network-wired",
    d: "M48.3,12.074H72.445V24.148H48.3ZM45.278,0a9.058,9.058,0,0,0-9.056,9.056V27.167a9.058,9.058,0,0,0,9.056,9.056h9.056V42.26H6.037a6.037,6.037,0,0,0,0,12.074H24.148v6.037H15.093a9.058,9.058,0,0,0-9.056,9.056V87.538a9.058,9.058,0,0,0,9.056,9.056H45.278a9.058,9.058,0,0,0,9.056-9.056V69.427a9.058,9.058,0,0,0-9.056-9.056H36.223V54.334h48.3v6.037H75.464a9.058,9.058,0,0,0-9.056,9.056V87.538a9.058,9.058,0,0,0,9.056,9.056h30.186a9.058,9.058,0,0,0,9.056-9.056V69.427a9.058,9.058,0,0,0-9.056-9.056H96.594V54.334h18.111a6.037,6.037,0,0,0,0-12.074h-48.3V36.223h9.056a9.058,9.058,0,0,0,9.056-9.056V9.056A9.058,9.058,0,0,0,75.464,0ZM18.111,84.52V72.445H42.26V84.52ZM78.482,72.445h24.148V84.52H78.482Z",
    fill: "#fefefe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfaSolidNetworkWired);
export default __webpack_public_path__ + "static/media/Icon fa-solid-network-wired.1cabd379b73f7db6af3a839ff514e824.svg";
export { ForwardRef as ReactComponent };